import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DesignServicesIcon from "@mui/icons-material/DesignServices";

const artificialIntelligence = {
  id: "group-artificialIntelligence",
  title: "Artificial Intelligence",
  type: "group",
  children: [
    {
      id: "house-comparison",
      title: "House Comparison",
      type: "item",
      url: "/house-comparison",
      icon: CompareArrowsIcon,
    },
    {
      id: "design-preview",
      title: "Design Preview",
      type: "item",
      url: "/design-preview",
      icon: DesignServicesIcon,
    },
  ],
};

export default artificialIntelligence;
